import { render, staticRenderFns } from "./FileInputDetails.vue?vue&type=template&id=2d2d68cc&scoped=true"
import script from "./FileInputDetails.vue?vue&type=script&lang=js"
export * from "./FileInputDetails.vue?vue&type=script&lang=js"
import style0 from "./FileInputDetails.vue?vue&type=style&index=0&id=2d2d68cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2d68cc",
  null
  
)

export default component.exports